import { useCallback } from "react";
import { toast } from "sonner";
import { useConnectivity } from "@/pwa/useConnectivity";
import { OFFLINE_MSG } from "@/lib/api";

// Shared guard so business-creating actions don't open forms with empty selectors while offline.
export function useOnlineGuard() {
  const online = useConnectivity();
  const guard = useCallback((fn) => (...args) => {
    if (!online) { toast.error(OFFLINE_MSG); return undefined; }
    return fn?.(...args);
  }, [online]);
  return { online, guard };
}
